import React from 'react';

type StatusFilterValue = 'all' | 'available' | 'reserved' | 'pending';
type SlotTypeFilterValue = 'all' | 'common' | 'preferred' | 'premium';

interface SlotFiltersProps {
  statusFilter: StatusFilterValue;
  slotTypeFilter: SlotTypeFilterValue | string;
  onStatusFilterChange: (value: StatusFilterValue) => void;
  onSlotTypeFilterChange: (value: string) => void;
}

export default function SlotFilters({
  statusFilter,
  slotTypeFilter,
  onStatusFilterChange,
  onSlotTypeFilterChange,
}: SlotFiltersProps) {
  return (
    <div className="bg-white shadow-sm rounded-lg p-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label htmlFor="slot-status-filter" className="block text-sm font-medium text-gray-700 mb-1">
            Status
          </label>
          <select
            id="slot-status-filter"
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value as StatusFilterValue)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
            aria-label="Filter slots by status"
          >
            <option value="all">All Statuses</option>
            <option value="available">Available</option>
            <option value="reserved">Reserved</option>
            <option value="pending">Pending</option>
          </select>
        </div>
        <div>
          <label htmlFor="slot-type-filter" className="block text-sm font-medium text-gray-700 mb-1">
            Slot Type
          </label>
          <select
            id="slot-type-filter"
            value={slotTypeFilter}
            onChange={(e) => onSlotTypeFilterChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
            aria-label="Filter slots by type"
          >
            <option value="all">All Types</option>
            <option value="common">Common</option>
            <option value="preferred">Preferred</option>
            <option value="premium">Premium</option>
          </select>
        </div>
      </div>
    </div>
  );
}
